import { TabsContent } from "@radix-ui/react-tabs";
import { styled } from "@vitality-ds/system";
import BaseTabContentStyles from "./styles/BaseTabContent.styles";
export default styled(TabsContent, BaseTabContentStyles);